import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { PagedResult } from '../../core/models/api.models';
import { NotificationDto, UnreadCountDto } from './notifications.models';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly api = inject(ApiService);
  private readonly base = 'notifications';

  list(params?: { page?: number; pageSize?: number }): Observable<PagedResult<NotificationDto>> {
    return this.api.getPaged<NotificationDto>(this.base, {
      page: params?.page ?? 1,
      pageSize: params?.pageSize ?? 50
    }).pipe(map(page => ({
      ...page,
      items: (page.items ?? []).map(row => this.normalize(row as unknown as Record<string, unknown>))
    })));
  }

  markRead(id: string): Observable<unknown> {
    return this.api.post(`${this.base}/${id}/read`, {});
  }

  markAllRead(): Observable<unknown> {
    return this.api.post(`${this.base}/mark-all-read`, {});
  }

  unreadCount(): Observable<number> {
    return this.api.get<UnreadCountDto | number>(`${this.base}/unread-count`).pipe(
      map(res => {
        if (typeof res === 'number') return res;
        return Number((res as UnreadCountDto)?.count ?? 0);
      })
    );
  }

  private normalize(row: Record<string, unknown>): NotificationDto {
    return {
      id: String(row['id'] ?? row['Id'] ?? ''),
      title: String(row['title'] ?? row['Title'] ?? 'Notification'),
      message: String(row['message'] ?? row['Message'] ?? ''),
      channel: row['channel'] as string | undefined,
      status: row['status'] != null ? Number(row['status']) : undefined,
      entityType: row['entityType'] as string | undefined,
      entityId: row['entityId'] as string | undefined,
      actionUrl: row['actionUrl'] as string | undefined,
      readAt: (row['readAt'] ?? row['ReadAt']) as string | null | undefined,
      sentAt: row['sentAt'] as string | undefined,
      createdAt: String(row['createdAt'] ?? row['CreatedAt'] ?? new Date().toISOString())
    };
  }
}
